import React, { CSSProperties, FC } from 'react';
import useStyles from './styles';

import NotificationReporter from '@shared/components/NotificationReporter';

import useDeviceDetect from '@src/shared/hooks/use-device-detect';

interface IContentProps {
  isFullScreen?: boolean;
  isHalfScreen?: boolean;
  overWriteStyle?: CSSProperties;
}

export const Content: FC<IContentProps> = ({
  children,
  isFullScreen,
  overWriteStyle,
  isHalfScreen,
}) => {
  const classes = useStyles();

  return (
    <>
      <main
        className={`${classes.contentSection} ${
          isFullScreen ? 'full-screen' : ''
        } ${isHalfScreen ? 'half-screen' : ''}`}
        style={{ ...overWriteStyle }}
      >
        {children}
      </main>

      <NotificationReporter />
    </>
  );
};

export default Content;
